// import axios from 'axios';
// import constants from '../constants';
// import authService from '../auth/AuthService';
import moment from 'moment';
import AppUsersClient from "../clients/AppUsersClient";

const resource = '/holiday';


export default {
    // Get's data for a given period and group. Group is mandatory. Data is grouped by type and user
    getAll() {
      return new Promise(function(resolve, reject) {      
        AppUsersClient.get(`${resource}`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
        });
    },   
    update(holiday) {
      return new Promise(function(resolve, reject) {      
        AppUsersClient.put(`${resource}`, holiday)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
        });
    } 
  };